<template>
  <div id="dashboard-live" v-if="live.data != null" v-loading="live.loading">
    <el-row :gutter="20">
      <el-col :span="6" v-for="(item, index) in live.data.cards" :key="index">
        <div class="data-card purple">
          <div class="card-info">
            <div class="title">
              <span>{{ item.title }}</span>
            </div>
            <div class="value">
              <span>{{ item.value }}</span>
            </div>
            <div class="description">
              <span>{{ item.description }}</span>
            </div>
          </div>
          <div class="card-icon">
            <i :class="item.icon"></i>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="statistics-container">
      <div class="overview-table-header">
        <h3>{{ $t("components.dashboard.summary") }}</h3>
        <!-- <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
          <el-button icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
        </el-tooltip> -->
      </div>

      <el-row :gutter="20">
        <el-col :span="16" class="pie-chart-container">
          <upgrade-overlay position="absolute" lottieWidth="150px" size="small" v-if="false"></upgrade-overlay>
          <el-table :data="live.data.liveEventStatistics" style="width: 100%">
            <el-table-column label="" width="60">
              <template slot-scope="scope">
                <span>
                  <i class="fas" :class="scope.row.isLive ? 'fa-video' : 'fa-clock'" :style="scope.row.isLive ? 'color: #FF6565;' : 'color: #FFD100;'"></i>
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('components.dashboard.live.hall')" min-width="180">
              <template slot-scope="scope">
                <span>
                  <b>{{ scope.row.title }}</b>
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('components.dashboard.live.onlineMeasurement')" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.watcherCount }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('components.dashboard.live.broadcastTime')" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.duration }} {{ $t("components.dashboard.live.minute") }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="8">
          <div class="recording-calculate">
            <div class="calculating-chamfer">
              <div class="calculating-percent" :style="'height:70%;'"></div>
              <div class="calculating-inner-chamfer">
                <div class="calculating-inner">
                  <h3>{{ (live.data.recording.usage / 1024).toFixed(2) }} GB</h3>
                  <span>{{ $t("components.dashboard.live.totalFiles", [live.data.recording.message]) }}</span>
                </div>
              </div>
            </div>
            <span>{{ $t("components.dashboard.live.recordingMessage") }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "Live",
  data() {
    return {};
  },
  methods: {
    downloadReport() {
      axios.post("report/generalstatistics", {}).then(res => {
        this.$message.success(res.data.alert.message);
      });
    }
  },
  async beforeMount() {
    if (this.live.data == null) {
      await this.$store.dispatch("getLive", {});
    }
  },
  async mounted() {},

  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    live() {
      var dummyLive = this.$store.getters.getDashboardLive;
      if (dummyLive.data != null) {
        if (false) {
          var dummy = JSON.parse(JSON.stringify(dummyLive.data.liveEventStatistics.slice(0, 3)));
          dummy = dummy.map(x => {
            return {
              ...x,
              duration: 0,
              startDate: new Date(),
              endDate: new Date(),
              watcherCount: 0
            };
          });
          dummyLive.data.liveEventStatistics = dummy;
        }
      }

      return dummyLive;
    }
  },

  beforeDestroy() {}
};
</script>

<style lang="less">
.recording-calculate {
  width: 100%;
  padding: 16px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .calculating-chamfer {
    background-color: transparent;
    position: relative;
    min-width: 240px;
    height: auto;
    aspect-ratio: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 50%;

    &::before {
      content: "";
      box-shadow: inset 0px 0px 17px -8px rgba(0, 0, 0, 0.75);
      position: absolute;
      z-index: 2;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }

    .calculating-percent {
      background-color: #50bfbf;
      position: absolute;
      width: 100%;
      height: 100%;
      bottom: 0;
      align-self: flex-end;
    }

    .calculating-inner-chamfer {
      position: absolute;
      width: 60%;
      height: 60%;
      border-radius: 50%;
      background-color: white;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-shadow: 0px 0px 17px -8px rgba(0, 0, 0, 0.75);

      .calculating-inner {
        position: relative;
        text-align: center;
        h3 {
          color: #292f3b;
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 4px !important;
          line-height: normal;
        }
        span {
          color: #505763;
          font-size: 13px;
          font-weight: 400;
        }
      }
    }
  }
  span {
    margin-top: 10px;
    color: #505763;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Live.vue